<template>
  <div class="flex flex-col gap-4">
    <template v-if="isLoading">
      <div v-for="index in 5" :key="'blog-skeleton-' + index" class="flex items-center gap-3">
        <ui-skeleton class="h-15 w-25 shrink-0 rounded-2xl" />
        <div class="flex flex-1 flex-col gap-2">
          <ui-skeleton class="h-4 w-4/5" />
          <ui-skeleton class="h-3 w-28" />
        </div>
      </div>
    </template>

    <p v-else-if="blogposts.length === 0" class="m-0 flex h-36 items-center justify-center text-sm text-muted-foreground">
      {{ tr('There are no items available.') }}
    </p>

    <template v-else>
      <div v-for="(blog, index) in blogposts" :key="'blog-' + index" class="flex items-center gap-3">
        <a :href="blog.link" target="_blank" class="h-15 w-25 shrink-0 overflow-hidden rounded-2xl bg-muted">
          <img
            v-if="coverOf(blog)"
            :src="coverOf(blog)"
            alt=""
            class="size-full object-cover"
          >
        </a>
        <div class="flex min-w-0 flex-1 flex-col gap-1">
          <a :href="blog.link" target="_blank" class="line-clamp-2 text-sm leading-tight font-medium text-foreground no-underline hover:underline">
            {{ blog.title.rendered }}
          </a>
          <time class="text-xs text-muted-foreground">{{ formatToStringYMD(new Date(blog.date_gmt), tr) }}</time>
        </div>
        <arrow-link :to="blog.link" :label="blog.title.rendered" />
      </div>
    </template>
  </div>
</template>

<script>
import BlogService from '@/services/Blog.js';
import ArrowLink from '@/ui/components/ArrowLink.vue';
import { formatToStringYMD } from '@/utils/date';

/** The latest Infinite∞Blog posts. */
export default {
  name: 'DashboardBlogBox',
  components: {
    ArrowLink,
  },
  data: () => ({
    isLoading: true,
    blogposts: [],
  }),
  watch: {
    '$root.language'() {
      this.loadPosts();
    },
  },
  created() {
    this.loadPosts();
  },
  methods: {
    formatToStringYMD,
    loadPosts() {
      this.isLoading = true;

      BlogService.getLatests(this.$root.language)
        .then(posts => this.blogposts = posts)
        .catch(() => {
          this.blogposts = [];
        })
        .finally(() => this.isLoading = false);
    },
    coverOf(blog) {
      const images = blog.yoast_head_json?.og_image;

      return Array.isArray(images) && images.length > 0 ? images[0].url : null;
    },
  },
};
</script>
